import { ICompleteTodo, ICreateTodo, ITodo, IEditTodo, IHideTodo} from '@app-types/websocket/todo.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

/** Email the todos PDF using the same request flow as saveEconomy. */
export function saveTodos(): boolean {
  if (!socket.hasConnection()) {return false;}
  socket.sendJSON({saveTodos: true});
  return true;
}

export function createTodo(data: ICreateTodo) {

  socket.sendJSON({
    newTodo: data,
  });
}

export function editTodo(data: IEditTodo) {

  socket.sendJSON({
    editTodo: data,
  });
}

export function deleteTodo(data: number) {

  socket.sendJSON({
    deleteTodo: data,
  });
}

export function completeTodo(data: ICompleteTodo) {

  socket.sendJSON({
    completeTodo: data,
  });
}

export function completeHandover(scheduleId: number) {

  socket.sendJSON({
    completeHandover: scheduleId,
  });
}
export function hideTodo(data: IHideTodo) {

  socket.sendJSON({
    hideTodo: data,
  });
}
export function seenTodo(data: IHideTodo) {

  socket.sendJSON({
    seenTodo: data,
  });
}


// WEBPACK FOOTER //
// ./src/services/todos/todo.websocket.ts